import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { createDynamicProfileForm } from 'services/dynamicProfiles/duck';
import { push } from 'connected-react-router';
import { fetchList as fetchBrandList } from 'services/brands/duck';
import EditForm from 'components/organisms/forms/EditDynamicProfile';

class CreateDynamicProfileContainer extends Component {
    componentDidMount() {
        this.props.fetchBrandList();
    }

    render() {
        return (
            <EditForm
                handleSubmit={this.props.handleSubmit.bind(null, createDynamicProfileForm)}
                dispatch={this.props.dispatch}
                brands={this.props.brands}
                pristine={this.props.pristine}
                currentUserScope={this.props.currentUser.scope}
                cancel={() => this.props.push('/admin/dynamic-profiles')} >
                {this.props.children}
            </EditForm>
        );
    }
}

const mapStateToProps = state => ({
    brands: state.brands.list,
    initialValues: {
        isActive: true
    }
});

export default compose(
    connect(mapStateToProps, { push, fetchBrandList }),
    reduxForm({
        form: 'editDynamicProfile',
        enableReinitialize: true,
    })
)(CreateDynamicProfileContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/dynamicProfiles/CreateDynamicProfileContainer.js